export default __webpack_public_path__ + "static/media/gallery.b9a0e425.svg";